// extracted by mini-css-extract-plugin
export default {"box":"DashboardPage_box__aRGat","reserve":"DashboardPage_reserve__BEUJ3","empty":"DashboardPage_empty__N6pZr"};